import { render, staticRenderFns } from "./ExternalUrl.vue?vue&type=template&id=372d0dd4&scoped=true&"
import script from "./ExternalUrl.vue?vue&type=script&lang=js&"
export * from "./ExternalUrl.vue?vue&type=script&lang=js&"
import style0 from "./ExternalUrl.vue?vue&type=style&index=0&id=372d0dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d0dd4",
  null
  
)

export default component.exports